export default __webpack_public_path__ + "static/media/sre-automation-book2.a8a6657e.png";